import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['passQcAnywayCheckbox', 'passQcButton', 'skipValidation']
  static values = { passQcAnywayMessage: String, confirmMessage: String }

  async handlePassQcAnyway(event) {
    if (this.passQcAnywayCheckboxTarget.checked) {
      event.preventDefault()

      const confirmController = this.application.getControllerForElementAndIdentifier(
        document.querySelector('[data-controller~="confirm"]'),
        'confirm',
      )
      const ok = await confirmController.request({ message: this.passQcAnywayMessageValue })

      if (ok) {
        this.passQcButtonTarget.disabled = false
        this.skipValidationTarget.value = true
        this.passQcAnywayCheckboxTarget.checked = true
      } else {
        this.cancelPassQc()
      }

      this.passQcAnywayCheckboxTarget.dispatchEvent(new Event('change', { bubbles: true }))
    } else {
      this.cancelPassQc()
    }
  }

  async confirmPassQc(event) {
    event.preventDefault()

    const form = event.target.closest('form')
    const confirmController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller~="confirm"]'),
      'confirm',
    )
    const userConfirmed = await confirmController.request({ message: this.confirmMessageValue })

    if (userConfirmed) {
      form.requestSubmit()
    } else {
      this.cancelPassQc()
    }
  }

  cancelPassQc() {
    if (!this.hasPassQcAnywayCheckboxTarget) return
    this.passQcAnywayCheckboxTarget.checked = false
    this.passQcButtonTarget.disabled = true
    this.skipValidationTarget.value = false
  }
}
